import { render, staticRenderFns } from "./CreateAgreementV2.vue?vue&type=template&id=2cfbc5d4"
import script from "./CreateAgreementV2.vue?vue&type=script&lang=js"
export * from "./CreateAgreementV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports